import { actionTypes } from '../actions/usuarios.action';
const initialState = {
    usuarios: {
        data: []
    },
    rifas: {
        data: []
    },
    bilhetes: {
        data: []
    }
}

const usuariosReducer = (state = initialState, { type, payload, isLoadMore }) => {
    switch (type) {

    case actionTypes.INDEX:
        if(isLoadMore) {
            payload.usuarios.data = state.usuarios.data.concat(payload.usuarios.data)
        }

        return { ...state, ...payload }

    case actionTypes.RIFAS:
        if(isLoadMore) {
            payload.rifas.data = state.rifas.data.concat(payload.rifas.data)
        }

        return { ...state, ...payload }

    case actionTypes.BILHETES:
        if(isLoadMore) {
            payload.bilhetes.data = state.bilhetes.data.concat(payload.bilhetes.data)
        }

        return { ...state, ...payload }

    case actionTypes.UPDATE:
        let bilhete = state.bilhetes.data.findIndex(item => item.id === payload.id)

        state.bilhetes.data[bilhete].status = 3

        return { ...state }

    default:
        return state
    }
}

export default usuariosReducer